// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"444ccce6","65":"8576c099","242":"f004a27d","275":"91044b85","383":"ca4d2fe6","478":"c3de5433","497":"7bcadc78","531":"a8652660","657":"e41c336b","663":"993e75fe","737":"3000c306","780":"db02c7d9","938":"fffd7de7","946":"7432aa79"}[chunkId] + ".chunk.js";
};